import { APP_BASE_URL } from "../../config/api";
import { authFetchJson } from "../../utils/api";

// Login history APIs now live under /api/admin
const BASE_URL = `${APP_BASE_URL}/api/admin/login-history`;

export async function getLoginHistory(limit = 50, offset = 0) {
  try {
    const url = `${BASE_URL}?limit=${limit}&offset=${offset}`;
    return await authFetchJson(url);
  } catch (error) {
    console.error("Error fetching login history:", error);
    throw error;
  }
}

export async function getAccountLoginHistory(
  accountId,
  limit = 50,
  offset = 0,
) {
  try {
    const url = `${APP_BASE_URL}/api/admin/login-history/account/${accountId}?limit=${limit}&offset=${offset}`;
    return await authFetchJson(url);
  } catch (error) {
    console.error(
      `Error fetching login history for account ${accountId}:`,
      error,
    );
    throw error;
  }
}

export async function getLoginSummary() {
  try {
    const url = `${APP_BASE_URL}/api/admin/login-history/summary`;
    return await authFetchJson(url);
  } catch (error) {
    console.error("Error fetching login summary:", error);
    throw error;
  }
}

export default {
  getLoginHistory,
  getAccountLoginHistory,
  getLoginSummary,
};
